const cssNameSpace = 'ripple';
const duration = 1000;
const background = 'currentColor';
const zIndex = 1;
const isDisabled = false;
const isStopPropagation = false;
export default{
    cssNameSpace,
    background,
    duration,
    zIndex,
    isDisabled,
    isStopPropagation
};


// WEBPACK FOOTER //
// ./src/directives/ripple/module/config.js